import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';

export const DisclaimerContainer = styled.div`
    border-bottom: solid 1px #282828;
    border-top: solid 1px #282828;
    width: 80%;
    margin-bottom: 5rem;
    padding: 1.5rem 0rem 1.5rem 0rem;

    @media screen and (max-width: 950px) {
        padding: 1rem 0rem 1rem 0rem;
    }
`;

export const DisclaimerText = styled.div`
    ${TextStyle({ fontSize: '18px', fontWeight: '600' })}
    line-height: 1.2;
    font-style: italic;
    padding: 0 0.3rem 0 0.3rem;

    @media screen and (max-width: 950px) {
        ${TextStyle({ fontSize: '16px', fontWeight: '600' })}
    }
`;
